import { LoadingButton } from '@mui/lab';
import { Box, Checkbox, Divider, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel, Stack, Typography } from '@mui/material';

import { FormProvider, RHFTextField } from 'src/components/hook-form';

import { useCategoryCollapse } from './category-collapse-hook';

export interface CategoryCollapseProps {
  data: any;
  getData: () => void;
}

export default function CategoryCollapse({ data, getData }: CategoryCollapseProps) {
  const { theme, isSubmitting, success, values, handleChange, onSubmit, methods } = useCategoryCollapse(data, getData);
  return (
    <FormProvider methods={methods} onSubmit={onSubmit}>
      <Stack direction='row' justifyContent='space-between' alignItems='center' spacing={6}>
        <Stack direction='row' spacing={6} alignItems='center' width='100%'>
          <Stack data-testid="tableCollapse-render-test" width='50%' spacing={1}>
            <Typography typography="bold-bd-md">Categoria</Typography>
            <RHFTextField name="name" variant="standard" placeholder="Nome da Categoria" />
          </Stack>
          <Divider
            orientation="vertical"
            flexItem
            sx={{
              width: '1px',
              backgroundColor: theme.palette.greyScale[100],
            }}
          />
          <Stack data-testid="tableCollapseType-render-test" width='50%' spacing={1}>
            <Stack spacing={1}>
              <FormControl error={!!methods.formState.errors.types}>
                <FormLabel
                  sx={{
                    typography: 'bold-bd-md',
                    color: theme.palette.greyScale[600],
                  }}
                >
                  Tipo
                </FormLabel>
                <FormGroup row>
                  <FormControlLabel value="events" control={<Checkbox checked={values.types.includes('events')} onChange={handleChange} />} label="Eventos" />
                  <FormControlLabel value="restaurant" control={<Checkbox checked={values.types.includes('restaurant')} onChange={handleChange} />} label="Restaurantes" />
                  <FormControlLabel value="stores" control={<Checkbox checked={values.types.includes('stores')} onChange={handleChange} />} label="Lojas" />
                  <FormControlLabel value="service" control={<Checkbox checked={values.types.includes('service')} onChange={handleChange} />} label="Serviços" />
                </FormGroup>
                {methods.formState.errors.types && <FormHelperText>{methods.formState.errors.types.message}</FormHelperText>}
              </FormControl>
            </Stack>
          </Stack>
        </Stack>
        <Stack>
          <Stack>
            <LoadingButton
              loading={isSubmitting}
              variant="contained"
              type="submit"
              sx={{
                paddingX: 10,
                borderRadius: 0,
                typography: 'body-md',
                backgroundColor: 'primary.main',
                '&:hover': {
                  backgroundColor: 'brand.400',
                },
              }}
            >
              Salvar
            </LoadingButton>
            <Box height="6px" />
            {success && (
              <Typography typography="body-md" color="feedback.success" align="center">
                Dados salvos com sucesso!
              </Typography>
            )}
          </Stack>
        </Stack>
      </Stack>
    </FormProvider>
  );
}
